var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-n6"},[_c('my-services',{staticClass:"div-my-service",attrs:{"serviceInfo":_vm.index.section2}}),_c('my-announcement',{staticClass:"div-my-announcement"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }